import { render, staticRenderFns } from "./RsaPazienteSchedeValutazionePage.vue?vue&type=template&id=d265ab9e"
import script from "./RsaPazienteSchedeValutazionePage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteSchedeValutazionePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports